/*
    Removes all forward slashes potentially located at the end of "text"
*/
export const removeTrailingForwardSlashes = text => {
  let correctText = text;
  while (correctText.slice(-1) === '/') {
    correctText = correctText.slice(0, -1);
  }
  return correctText;
};
